export default () => ({
    showUpsells: Alpine.$persist({}).as('show-upsells'),

    init() {
        Livewire.dispatch('cart::load');

        window.addEventListener('cart::mainEvent', ({detail: mainEvent}) => {
            this.$store.cart.showUpsell = _.get(this.showUpsells, mainEvent[0].id, true);

            Livewire.dispatch('load::discount');
        });
    },

    flag(item) {
        return item.is_digital
            ? 'digital product'
            : (item.package.shipping_price ? null : 'Shipping Included!');
    },

    place() {
        this.$dispatch('close::payment-method::form');
        this.$dispatch('close::my-account::form');

        if (this.$store.customer.item.discount && !this.$store.cart.items.filter((item) => item.package.upsell).length && this.$store.cart.showUpsell) {
            this.$dispatch('open-upsell-items-modal');

            return;
        }

        this.fillPackages();

        if (
            this.$store.cart.items.every(
                (item) => (item.package.template.requirement_images.length && !Object.values(item.images).length) ||
                    (item.images.all !== undefined && !Object.values(item.images.all).length)
            )
        ) {
            window.$wireui.notify({
                title: 'Required Images',
                description: 'You have to add images to your prepaid package!',
                icon: 'warning'
            });

            return;
        }

        this.next();
    },

    next() {
        if(! this.$store.customer.hasInfo()){
            this.$dispatch('open-create-account');

            return;
        }

        this.$wire.dispatch('customer::form::setStep', {step: 'agreements'});
        this.$dispatch('place-order');
        this.$dispatch('close-cart');
    },

    keep() {
        this.$wire.dispatch('customer::form::keep');
        this.$dispatch('close-cart');
    },

    edit(index) {
        const data = _.get(this.$store.cart.items, index);

        this.$dispatch('edit-package', data);
        this.$dispatch('close-cart');
    },

    handleUpsellModal(value=true) {
        this.showUpsells[this.$store.cart.mainEvent.id] = value;
        this.$store.cart.showUpsell                     = value;
    },

    fillPackages() {
        this.$store.cart.items.map(
            (item) => {
                if (item.package.template.is_digital === 'All Photos in Album' && !_.size(item.images.all)) {
                    item.images.all = Object.values(this.$store.customerImages.images);
                }
            }
        );
    }
});
